import { render, staticRenderFns } from "./GameSmsForm.vue?vue&type=template&id=9eee2f10&scoped=true"
import script from "./GameSmsForm.vue?vue&type=script&lang=ts"
export * from "./GameSmsForm.vue?vue&type=script&lang=ts"
import style0 from "./GameSmsForm.vue?vue&type=style&index=0&id=9eee2f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eee2f10",
  null
  
)

export default component.exports